import React, { useEffect, useRef } from "react";
import styles from "./PrivacyModal.scss";

export function PrivacyModal({ isOpen, onClose }) {
  const modalRef = useRef(null);

  // ESCキーで閉じる
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  // オーバーレイクリックで閉じる
  const handleOverlayClick = e => {
    if (e.target === modalRef.current) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div ref={modalRef} className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose} aria-label="閉じる">
          <span></span>
          <span></span>
        </button>

        <h2 className={styles.modalTitle}>プライバシーポリシー</h2>

        <div className={styles.policyContent}>
          <section className={styles.policySection}>
            <h3>1. 個人情報の取得</h3>
            <p>
              東京科学大学 辻本研究室は、MetaCampUs
              Japan（以下「本サービス」といいます）の提供にあたり、以下の個人情報を取得することがあります。
            </p>
            <ul>
              <li>メールアドレス等の連絡先情報</li>
              <li>本サービスの利用履歴</li>
              <li>端末情報、IPアドレス、Cookie情報等のアクセス情報</li>
            </ul>
          </section>

          <section className={styles.policySection}>
            <h3>2. 個人情報の利用目的</h3>
            <p>当団体は、取得した個人情報を以下の目的で利用します。</p>
            <ul>
              <li>本サービスの提供・運営</li>
              <li>ユーザーからのお問い合わせへの対応</li>
              <li>本サービスの改善および新サービスの開発</li>
              <li>利用規約に違反する行為への対応</li>
            </ul>
          </section>

          <section className={styles.policySection}>
            <h3>3. 個人情報の第三者提供</h3>
            <p>
              当団体は、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供することはありません。ただし、以下の場合は除きます。
            </p>
            <ul>
              <li>法令に基づく開示請求があった場合</li>
              <li>人の生命、身体または財産の保護のために必要がある場合</li>
              <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
            </ul>
          </section>

          <section className={styles.policySection}>
            <h3>4. 個人情報の安全管理</h3>
            <p>
              当団体は、個人情報の紛失、破壊、改ざんおよび漏洩などを防止するため、適切なセキュリティ対策を実施します。
            </p>
          </section>

          <section className={styles.policySection}>
            <h3>5. Cookieの使用について</h3>
            <p>
              本サービスでは、ユーザー体験の向上およびサービスの改善のためにCookieを使用しています。ユーザーはブラウザの設定によりCookieの受け入れを拒否することができますが、その場合、本サービスの一部機能が利用できなくなる可能性があります。
            </p>
          </section>

          <section className={styles.policySection}>
            <h3>6. プライバシーポリシーの変更</h3>
            <p>
              当団体は、必要に応じて本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本サービス上に掲載した時点から効力を生じるものとします。
            </p>
          </section>

          <section className={styles.policySection}>
            <h3>7. お問い合わせ</h3>
            <p>本プライバシーポリシーに関するお問い合わせは、以下の連絡先までお願いいたします。</p>
            <p className={styles.contactInfo}>メール: contact@metacampus.jp</p>
          </section>
        </div>
      </div>
    </div>
  );
}
